import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    template_tests: [],
    total: 0,
    showModalRemoveTest: false,
    shouldBeRefresh: false,
    testTypesToFilter: [],
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_TEMPLATE_TESTS:
            return {
                ...state,
                template_tests: payload.template_tests,
                total: payload.total,
            };
        case actions.CHANGE_MODAL_REMOVE_TEMPLATE_TEST:
            return { ...state, showModalRemoveTest: payload };
        case actions.CHANGE_SHOULD_BE_REFRESH_TEMPLATE_TESTS:
            return { ...state, shouldBeRefresh: payload };
        case actions.CHANGE_TEST_TYPES_TO_FILTER:
            return { ...state, testTypesToFilter: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/tests/tests.reducer.js